import { ExperienceFlow } from '../../pages/GTBCustomize/ContextProviders/SharedContextTypes';

const GTB_FLOW: ExperienceFlow = 'gtb';
const PUBLIC_SHOP: ExperienceFlow = 'publicShop';

const EXPERIENCE_FLOW = {
  gtb: GTB_FLOW,
  publicShop: PUBLIC_SHOP,
};

export default EXPERIENCE_FLOW;
